import type React from 'react';
import ApexCharts from 'react-apexcharts';
import './Dynamicgraph.css';
import { Badge, Card } from 'antd';
import { BsFileEarmarkBarGraphFill } from 'react-icons/bs';

const DynamicGraph: React.FC<any> = ({ data, open }: any) => {
	const { data: seriesData, labels, 'y-axis': yAxisLabel, 'x-axis': xAxisLabel, 'preferred graph': graphtype } = data;

	const safeSeriesData = Array.isArray(seriesData) ? seriesData?.map((item: any) => (item === null ? 0 : item)) : [];

	let graphTypelower: any = graphtype?.toLowerCase();

	const chartType: any =
		graphTypelower === 'donut graph' || graphTypelower === 'pie chart'
			? 'donut'
			: graphTypelower === 'line graph'
				? 'line'
				: graphTypelower === 'bar graph'
					? 'bar'
					: 'line';

	// Define chart options for ApexCharts.
	const chartOptions: any = {
		chart: {
			type: chartType,
			toolbar: {
				show: true,
				tools: {
					download: true,
					selection: true,
					zoom: true,
					zoomin: true,
					zoomout: true,
					pan: true,
					reset: true
				}
			},
			// export: {
			// 	csv: {
			// 	  filename: 'full_data_export', // Custom filename
			// 	  columnDelimiter: ',',
			// 	  headerCategory: 'Full Label', // Custom header for the category
			// 	  headerValue: 'Value', // Header for values
			// 	  // Use full labels instead of truncated ones
			// 	  formatter: (series: any, opts: any) => {
			// 		const dataPointIndex = opts.dataPointIndex;
			// 		const fullLabel = opts.w.globals.labels[dataPointIndex];
			// 		const value = series[0][dataPointIndex];
			// 		return `${fullLabel},${value}`;
			// 	  },
			// 	},
			//   },
			animations: {
				enabled: true,
				easing: 'easeinout',
				speed: 800,
				animateGradually: {
					enabled: true,
					delay: 150
				},
				dynamicAnimation: {
					enabled: true,
					speed: 350
				}
			}
		},
		// tooltip: {
		// 	theme: 'light',
		// 	x: {
		// 	  formatter: (value: string) => {
		// 		// Ensure full label is shown without truncation
		// 		return value;
		// 	  },
		// 	},
		// 	y: {
		// 	  formatter: (value: number, { dataPointIndex, w }: any) => {
		// 		const fullLabel = w?.globals?.labels[dataPointIndex];
		// 		return `${value}: ➡️  ${fullLabel}`;
		// 	  },
		// 	},
		//   },

		tooltip:
			chartType === 'donut'
				? {
						theme: 'light',
						y: {
							formatter: function (value: number, { seriesIndex, w }: any) {
								const label = w?.config?.labels?.[seriesIndex];
								return `${value.toLocaleString()}`;
								//  return `${label}: ${value.toLocaleString()}`;
							}
						}
					}
				: {
						theme: 'light',
						x: {
							formatter: (value: string) => {
								// Ensure full label is shown without truncation
								return value;
							}
						},
						y: {
							formatter: (value: number, { dataPointIndex, w }: any) => {
								// const fullLabel = w?.globals?.labels[dataPointIndex];
								const fullLabel = w?.globals?.categoryLabels?.[dataPointIndex] ?? 'N/A';
								return `${value}: ➡️  ${fullLabel}`;
							}
						}
					},

		xaxis: {
			title: {
				text: xAxisLabel || 'Value',
				style: {
					fontSize: '12px',
					fontWeight: 500,
					fontFamily: 'NoirPro'
				}
			},
			categories: labels,
			labels: {
				style: {
					fontSize: '8px',
					fontWeight: 300,
					fontFamily: 'cursive'
				},
				tickPlacement: 'on',
				tooltip: {
					theme: 'light',
					y: {
						formatter: (value: number, { dataPointIndex, w }: any) => {
							// Access full label from data
							const fullLabel = w?.globals?.labels[dataPointIndex];
							return `${fullLabel}: ${value}`;
						}
					}
				}
				// formatter:
				// 	chartType === 'bar'
				// 		? (value: string) => {
				// 				return value?.length > 10 ? value?.substring(0, 10) + '...' : value;
				// 			}
				// 		: undefined,
			}
		},
		yaxis: {
			title: {
				text: yAxisLabel || 'Value',
				style: {
					fontSize: '12px',
					fontWeight: 500,
					fontFamily: 'NoirPro'
				}
			},
			labels: {
				style: {
					fontSize: '10px',
					fontWeight: 300,
					fontFamily: 'NoirPro'
				}
			}
		},
		stroke: {
			curve: 'smooth',
			width: chartType === 'bar' ? 0 : 3
		},
		fill: {
			type: 'fill',
			opacity: 1
		},
		colors: ['#03A9F5', '#fb923c', '#f43f5e', '#16a34a', '#7c3aed'],
		dataLabels:
			chartType === 'donut'
				? {
						enabled: true,
						formatter: function (val: number) {
							return `${val.toFixed(1)}%`;
						},
						style: {
							fontSize: '12px',
							fontWeight: 500
						}
					}
				: {
						enabled: false
					},
		grid: {
			borderColor: '#e7e7e7',
			row: {
				colors: ['#f3f3f3', 'transparent'],
				opacity: 1
			}
		},
		markers: {
			size: 5,
			colors: ['#3366FF'],
			strokeColors: '#fff',
			strokeWidth: 2,
			hover: {
				size: 7
			}
		},
		// tooltip: {
		// 	theme: 'light',
		// 	y: {
		// 		formatter: (value: number) => `${value}`
		// 	}
		// },
		legend: chartType === 'line'? {
						formatter: function (val: string) {
							return val; // Only show name (label), no value or percent
						}
					} : {
						formatter: function (val: any, opts: any) {
							const series = opts.w.globals.series;
							const seriesIndex = opts.seriesIndex;
							const total = series.reduce((sum: any, value: any) => sum + value, 0);
							const value = series[seriesIndex];
							const percent = ((value / total) * 100).toFixed(1);
							return `${val}: ${value} (${percent}%)`;
						}
					},
		responsive: [
			{
				breakpoint: 480,
				options: {
					chart: {
						width: '100%'
					},
					legend: {
						position: 'bottom'
					}
				}
			}
		],

		labels: chartType === 'donut' || chartType === 'bar' || chartType === 'line' ? labels : '',
		plotOptions: {
			bar: {
				columnWidth: '40%',
				barHeight: '60%',
				distributed: false,
				borderRadius: 5,
				borderRadiusApplication: 'end',
				borderRadiusWhenStacked: 'last'
			},
			pie: {
				donut: {
					labels: {
						show: true,
						name: {
							show: true
						},
						value: {
							show: true
							// formatter: function (val: number, opts: any) {
							// 	const total = opts?.globals?.labels.reduce((sum: number, v: number) => sum + v, 0);
							// 	const percent = (val / total) * 100;
							// 	return `${percent.toFixed(1)}%`;
							//  }
						}
					}
				}
			}
		}
	};

	let formattedSeriesData = safeSeriesData;
	if (safeSeriesData && typeof safeSeriesData === 'object' && !Array.isArray(safeSeriesData)) {
		formattedSeriesData = Object.keys(safeSeriesData).map((key) => safeSeriesData[key]);
	}

	// Check if the data is in an object format (where each element is an object with keys)
	const isObjectData = Array.isArray(formattedSeriesData) && typeof formattedSeriesData[0] === 'object';

	const series =
		chartType === 'donut'
			? // For donut charts, if we have object data, pick the numeric value from each object.
				isObjectData
				? formattedSeriesData.map((item: any) => Object.values(item).find((val) => typeof val === 'number') || 0)
				: formattedSeriesData
			: isObjectData
				? Object.keys(formattedSeriesData[0]).map((key) => ({
						name: key,
						data: formattedSeriesData.map((item: any) => (typeof item[key] === 'number' ? item[key] : 0))
					}))
				: [
						{
							name: yAxisLabel || 'Data',
							data: formattedSeriesData
						}
					];

	return (
		<div className={open ? 'Modal' : 'chartdiv'}>
			<Badge.Ribbon
				placement="start"
				text={
					<p
						style={{ fontFamily: 'NoirPro' }}
						className="gx-p-0 gx-mt-0 gx-m-0 gx-fs-sm gx-m-0 gx-d-flex gx-align-items-center gx-justify-content-center"
					>
						<span>
							<BsFileEarmarkBarGraphFill size={12} className="gx-mr-1 gx-mt-1" color="white" />
						</span>{' '}
						Graphical View
					</p>
				}
			>
				<Card style={{ borderTop: '5px solid #5ae75a' }}>
					<ApexCharts key={JSON?.stringify(data)} options={chartOptions} series={series} type={chartType} height="340" />
				</Card>
			</Badge.Ribbon>
		</div>
	);
};

export default DynamicGraph;